<div class="modal-header">
  <h4 class="modal-title" id="myModalLabel">Send Email to All Contacts or Mark Done Manually</h4>
</div>
<div class="modal-body">
  <app-results-list [service]="service" [searchObj]="searchObj" inputType="none" [showLink]="false"
                   [displayFields]="['relationship_type', 'contact_display_name', 'contact_phone_number',
                         'contact_email_address']"></app-results-list>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-warning" (click)="m.close('email')">Send Email</button>
  <button type="button" class="btn btn-warning" (click)="m.close()">Mark Done</button>
  <button type="button" class="btn btn-primary" (click)="m.dismiss()">Cancel</button>
</div>
